import React, { useState,useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { useDispatch, useSelector } from "react-redux";
import {
  ForgetPassword,
  LoginLoader,
  UserLogin,
} from "../../Redux/Action/LoginAction";
import { MdClose } from "react-icons/md";
import Select, { components } from "react-select";
import Loader from "./Loader";

//import image from image folder 
import eyeclose from "../../images/Login/eye close.svg";
import eyeopen from "../../images/Login/view.png";
import login1 from "../../images/Login/login2.png";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}
const Login = (history) => {
  const [contactno, setContactno] = useState("");
  const [Type, setType] = useState("contact");
  const [Email, setEmail] = useState("");
  const [selectedCorporate, setSelectedCorporate] = useState(null);
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();


  // const userToken=localStorage.getItem("Admin");
  // const userData=userToken?JSON.parse(userToken):null;
  // const userRole=userData?.data?.role;

  // useEffect(()=>{
  //   if(userRole==="adaccountant" || userRole==="adsales" || userRole==="adsupport" || userRole==="admanager"){
  //     navigate('/admin/admin_team/login')
  //   }else{
  //     navigate('/login')
  //   }
  // },[userRole])


  const handleSubmit = (e) => {
    e.preventDefault();
    let loginType;
    if(location.pathname==='/vfs_uk_lp/login' || location.pathname==='/onevasco/login'){
        loginType = 'Corporate';
    }else if(location.pathname==='/vfs_uk_lp/team/login'){
        loginType = 'team';
    }else if(location.pathname==='/admin/admin_team/login'){
      loginType = 'admin_team';
    }else{
      loginType = selectedCorporate?.value;
    }
    dispatch(
      UserLogin(
        Type === "contact" ? contactno : Email,
        password,
        loginType,
        Type,
        navigate
      )
    );
    dispatch(LoginLoader());
  };

  const [openForgotModal, setopenForgotModal] = useState(false);


  // for react select

  const customStyles = {
    //to remove seprator
    indicatorSeparator: () => ({}),

    control: (base) => ({
      ...base,
      background: "#FFF",
    }),
    control: (base, state) => ({
      ...base,
      height: "48px",
      boxShadow:
        "0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)",
      borderColor: state.isFocused ? "#fff" : "#808080",
      "&:hover": {
        borderColor: "#FCDD00",
      },
      padding: 3,
      border: "0px solid black",
      fontSize: 14,
      outline: "none",
      borderRadius: "8px",
      backgroundColor: "#fff",
    }),
    option: (base, state) => ({
      ...base,
      cursor: "pointer",
      color: "#000",
      backgroundColor: state.isSelected ? "#FCDD00" : "white",
      ":hover": {
        backgroundColor: "#FFFCE1",
      },
    }),
    menuList: (base) => ({
      ...base,
      maxHeight: "150px", // Set the desired max height
      overflow: "Y",
      "::-webkit-scrollbar": {
        width: "4px",
        height: "0px",
      },
      "::-webkit-scrollbar-track": {
        background: "#f1f1f1"
      },
      "::-webkit-scrollbar-thumb": {
        background: "#FCDD00"
      }
    }),
  };

  const loginOptions = [
    { value: "Admin", label: "Admin" },
    { value: "Corporate", label: "Corporate" },
    { value: "Hr", label: "HR" },
    { value: "Doctor", label: "Doctor" },
  ];

  function handleSelect(selectedOption) {
    setSelectedCorporate(selectedOption);
  }

  function onChangeValue(e) {
    setType(e.target.value);
  }

  const [passwordType, setPasswordType] = useState("password");
  const togglePassword = (e) => {
    e?.preventDefault();
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };

  const loader = useSelector((state) => state?.Auth?.loader);

  //for forget password
  const forgetOption = [
    { value: "Corporate", label: "Corporate" },
    { value: "Hr", label: "HR" },
    { value: "Doctor", label: "Doctor" },
  ];

  const [email, setemail] = useState("");
  const [selectedType, setSelectedType] = useState(null);

  
  function handleselect(SelectedOption) {
    setSelectedType(SelectedOption);
  }

  const handleSave = (e) => {
    e.preventDefault();
    let loginType;
    if(location.pathname==='/vfs_uk_lp/login' || location.pathname==='/onevasco/login'){
        loginType = 'Corporate';
    }else if(location.pathname==='/vfs_uk_lp/team/login'){
        loginType = 'team';
    }else if(location.pathname==='/admin/admin_team/login'){
      loginType = 'admin_team';
    }else{
      loginType = selectedType?.value;
    }
    const formData = {
      email,
      logintype: loginType,
    };
    dispatch(ForgetPassword(formData));
    dispatch(LoginLoader());
  };

  //for close forget password popup 
  const newData = useSelector((state) => state?.Auth?.forgetpassword)
  useEffect(()=>{
    if(newData.code === 200){
      setopenForgotModal(false);
      setemail("")
      setSelectedType(null)
    }
  },[newData])

  const query = useQuery();

  const mobileNumber = query.get('m_no');
  const pass = query.get('pass');
  const type = query.get('type');

  
  useEffect(() => {
    if(mobileNumber && pass){
      setContactno(mobileNumber)
      setPassword(pass)
    }
    if (mobileNumber && pass && type && Type === "contact") {
      setContactno(mobileNumber);
      setPassword(pass);
      const selectedOption = loginOptions.find(opt => opt.value === type);
      if (selectedOption) {
        setSelectedCorporate(selectedOption);
      }
    }
  }, []);

  return (
    <div className="flex justify-between h-[100vh] card bg-gold relative">
      {loader && (
        <div>
          <div className="fixed top-0 left-0 right-0 z-50 w-full h-full bg-black bg-opacity-50">
            <div className="z-[50] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
              <Loader />
            </div>
          </div>
        </div>
      )}
      {/*--------------------------------------------------------------- Left Side Content-------------------------------------------------------------- */}
      <div className="flex flex-col justify-center basis-1/2 left-container">
        <div>
          <div className="flex flex-col items-center justify-center gap-3">
            <div>
              <img src="data:image/png;base64,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"></img>
            </div>
            <div className="font-Roboto text-xl text-[#1A1A1A]">
              Welcome back!
            </div>
            {/* <div>
              <div className="text-[#1A1A1A] text-2xl font-Roboto text-center">
                <span className="text-sm">Ensure </span> Health & Wellbeing
              </div>
              <div className="text-[#1A1A1A]text-sm font-Roboto text-center">
                of your <span className="text-2xl">Family</span> with{" "}
                <span className="text-[#FCDD00] text-4xl">Homeopathy</span>
              </div>
              
            </div> */}
            <div>
            <div className="text-[#1A1A1A] text-lg font-Roboto text-center">
                <span className="text-sm text-gray-500">Ensure </span> Health & Wellbeing <span className="text-sm text-gray-500">of your Human </span>
              </div>
              <div className="text-[#1A1A1A] text-lg font-Roboto text-center">
                <span className="text-sm text-gray-500" >Capital with  </span>Holistic & Integrative <span className="text-sm text-gray-500">Care Solutions</span> 
              </div>
              <div className="text-sm text-center text-gray-500 font-Roboto">
              from the House of
                <span className="text-[#FCDD00] text-2xl"> WelcomeCure</span>
              </div>
              {/* <p>Ensure Health & Wellbeing of your Human Capital with Holistic & Integrative Care Solutions from the House of WelcomeCure</p> */}
            </div>
            <div className="">
              <img src={login1} className=" w-[280px] h-[280px] 2xl:w-[380px] 2xl:h-full" />
            </div>
          </div>
        </div>
      </div>
      {/*--------------------------------------------------------------- Right Side Content-------------------------------------------------------------- */}
      <div className="flex flex-col items-center justify-center basis-1/2 right-container">
        <div className="flex flex-col w-[377px] login-form">
          <p className="mb-5 text-2xl text-center font-Roboto">
            Sign In to WelcomeCure
          </p>
          <div>
            <form className="flex flex-col gap-2" onSubmit={handleSubmit}>
              <div className="flex flex-col gap-2">
                <label className="font-Roboto text-sm text-[#1A1A1A]">
                  Mobile Number / Email<span className="text-[#fc0000]"> *</span>
                </label>
                <input
                  placeholder={
                    Type === "contact" ? "Enter Mobile Number" : "Enter Email"
                  }
                  required
                  type={Type === "contact" ? "text" : "email"}
                  className="form-control form-control bg-white p-3 rounded-md shadow-lg focus:outline-none  [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                  value={Type === "contact" ? contactno : Email}
                  autoComplete="off"
                  onChange={(e) => {
                    const inputText = e.target.value;
                    if (Type === "contact" || e.target.type === "number") {
                      const numericValue = inputText.replace(/[^0-9]/g, "");
                      const limitedNumericValue = numericValue
                      Type === "contact"
                        ? setContactno(limitedNumericValue)
                        : setEmail(inputText.trim());
                    } else {
                      Type === "contact"
                        ? setContactno(inputText)
                        : setEmail(inputText.trim());
                    }
                  }}
                />
                {Type === "email" ? (
                  <div
                    onClick={() => setType("contact")}
                    className=" cursor-pointer text-[14px]"
                  >
                    Use Mobile No Instead
                  </div>
                ) : (
                  <div
                    onClick={() => setType("email")}
                    className=" cursor-pointer text-[14px]"
                  >
                    Use Email Instead
                  </div>
                )}
              </div>

              <div className="relative flex flex-col gap-2">
                <label className="font-Roboto text-sm text-[#1A1A1A]">
                  Password <span className="text-[#fc0000]">*</span>
                </label>
                <input
                  placeholder="Enter Password"
                  required
                  type={passwordType}
                  className="p-3 bg-white rounded-md shadow-lg form-control focus:outline-none"
                  value={password}
                  onChange={(e) => {
                    const trimmedValue = e.target.value.trim();
                    setPassword(trimmedValue);
                  }}
                  autoComplete="off"
                />
                <div className="absolute right-4 top-[40px] z-0 bg-white py-1">
                  <button onClick={togglePassword}>
                    {passwordType === "password" ? (
                      <img src={eyeopen} alt="new"></img>
                    ) : (
                      <img src={eyeclose} alt="new"></img>
                    )}
                  </button>
                </div>
              </div>
              {["/vfs_uk_lp/login", "/onevasco/login","/vfs_uk_lp/team/login","/admin/admin_team/login"].includes(location.pathname) ?
              ""
              :
              (
                <div className="flex flex-col gap-2">
                  <label className="font-Roboto text-sm text-[#1A1A1A]">
                    Select Login Type <span className="text-[#fc0000]">*</span> 
                  </label>
                  <Select
                  className=""
                    options={loginOptions}
                    placeholder="Select Login Type"
                    value={selectedCorporate}
                    onChange={handleSelect}
                    isSearchable={false}
                    styles={customStyles}
                    menuPortalTarget={document.body} 
                    menuPosition={'fixed'}
                    required
                    components={{
                      Input: (props) => (
                        <components.Input {...props} required maxLength={0} />
                      ),
                    }}
                  />
                </div>
              )}
               {/* {["/vfs_uk_lp/login", "/onevasco/login","/vfs_uk_lp/team/login"].includes(location.pathname) ?
              <div className="flex justify-between">
              
              </div>
              :
              (
              
              )} */}
              <div className="flex justify-between">
                <div
                  className="text-sm text-[#1A1A1A] font-Roboto cursor-pointer ml-auto"
                  onClick={() => setopenForgotModal(true)}
                >
                  Forgot Password ?
                </div>
              </div>
              <button
                className="flex justify-center bg-[#FCDD00] hover:shadow-xl hover:transition-all duration-700 rounded-lg p-4 text-sm font-Roboto text-[#1A1A1A] outline-none"
                type="submit"
              >
                Sign In
              </button>
            </form>
          </div>
          <ToastContainer />
        </div>
      </div>
      {/* forget password modal */}
      {openForgotModal && (
        <div className="fixed top-0 left-0 right-0 z-30 w-full h-full bg-black bg-opacity-50">
          <div className=" bg-white min-w-[340px] max-w-[450px] absolute top-[50%] left-[50%] transform -translate-x-[50%]  -translate-y-[50%] rounded-[10px] p-5">
            <div className="flex items-center justify-between border-b border-[#dfdfdf] pb-3">
              <p className="text-xl text-[#1A1A1A] font-Roboto font-medium">
                Forgot your Password?
              </p>
              <MdClose
                className="text-2xl text-gray-500 cursor-pointer hover:text-black"
                onClick={() => setopenForgotModal(false)}
              />
            </div>
            <div className="pt-5">
              <p className="text-sm text-[#1A1A1A] font-Roboto font-medium">
                WelcomeCure will send password reset instructions to the email
                address associated with your account. Please provide your
                registration Email.
              </p>
              <form className="flex flex-col gap-5" onSubmit={handleSave}>
              {["/vfs_uk_lp/login", "/onevasco/login","/vfs_uk_lp/team/login","/admin/admin_team/login"].includes(location.pathname) ?
              ""
              :
              (
                <div className="flex flex-col gap-2">
                  <label className="font-Roboto text-sm text-[#1A1A1A] mt-5">
                    Select Login Type <span className="text-[#fc0000]">*</span>
                  </label>
                  <Select
                    options={forgetOption}
                    placeholder="Select Login Type"
                    value={selectedType}
                    onChange={handleselect}
                    isSearchable={false}
                    styles={customStyles}
                    required
                    components={{
                      Input: (props) => (
                        <components.Input {...props} required maxLength={0} />
                      ),
                    }}
                  />
                </div>
                )}
                <div className="flex flex-col gap-2">
                  <label className="font-Roboto text-sm text-[#1A1A1A]">
                    Registered Email <span className="text-[#fc0000]">*</span>
                  </label>
                  <input
                    placeholder="Enter Email"
                    required
                    type="email"
                    className="form-control form-control bg-white p-4 rounded-md shadow-lg focus:outline-none  [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                    value={email}
                    onChange={(e) => {
                      setemail(e.target.value);
                    }}
                    autoComplete="off"
                  ></input>
                </div>

                <button
                  className="flex justify-center bg-[#FCDD00] hover:shadow-xl hover:transition-all duration-700 rounded-lg p-4 text-sm font-Roboto text-[#1A1A1A]"
                  type="submit"
                >
                  Submit
                </button>
              </form>
            </div>
          </div>
        </div>
      )}
      {/* forget password modal over */}
    </div>
  );
};

export default Login;
